import employerPath from './employer'
import meetingPath from './meeting'
import profilePath from './profile'
import vacancyPath from './vacancy'
import resumePath from './resume'

export {vacancyPath, resumePath, profilePath, employerPath, meetingPath}
